import { defineComponent as _defineComponent } from 'vue'
import TopbarLocation from './TopbarLocation.vue';
import TopbarLanguage from './TopbarLanguage.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'AppTopbar',
  setup(__props) {


return { __sfc: true,TopbarLocation, TopbarLanguage }
}

})